// extracted by mini-css-extract-plugin
module.exports = {"Table":"style_Table__7h3ZU","Item":"style_Item__1IqJd","TableHeading":"style_TableHeading__2CLnN","TableImage":"style_TableImage__2ay01"};